export const NAME = 'barChart'

export const hours = [
  'FOH',
  'LOST_EHRS',
  'MEH',
  'MOH',
  'PH',
  'POH',
  'PUMPHOUR',
  'RESHOUR',
  'RUH',
  'SEH',
  'SERVHOUS',
]
export const count = ['NUMFO', 'NUMME', 'NUMMO', 'NUMPE', 'NUMPO', 'NUMRS', 'NUMSF']
export const rating = ['DEH', 'EFDH', 'EFORD', 'EMDH', 'EPDH', 'PDEH']
export const mw = ['LOST_MWH', 'NETACTGEN', 'NETDEPCAP', 'NETMAXCAP']

export const dollars = [
  'ACTUAL_MARGIN',
  'ACTUAL_REVENUE',
  'LOST_MARGIN',
  'LOST_REVENUE',
  'TARGET_REVENUE',
  'TOTAL_COST',
]
